import {
  Box,
  Stack,
  Typography
} from '@mui/material';
import { CustomIcons } from 'modules/components/layer00';
import { ReactNode } from 'react';



export interface ChatPaneHeaderProps {
  children?: ReactNode | ReactNode[];
  ticker: string;
  companyName: string;
}

export const FC = (props: ChatPaneHeaderProps) => {
  const value = props.companyName && props.ticker ? `${props.companyName} - (${props.ticker})` : '';
  return (
    <>
      <Box
        padding='1.5rem'
        display='flex'
        flexWrap='wrap'
        flexDirection='row'
        alignItems='center'
        justifyContent='space-between'

      >
        <Stack direction='column' spacing={2} alignItems='flex-start'>
          <CustomIcons.LargeIcon.FC icon='COMPANYLOGOFULLLIGHT' />

          <Typography
            variant='activityHeader'
            sx={{
              color: 'white'
            }}
          >{value}
          </Typography>
        </Stack>
      </Box>

      <Box
        display='flex'
        flexWrap='wrap'
        justifyContent='space-between'
        paddingX='.88rem'
        marginBottom='-1rem'
        zIndex={100}
      >
        {props.children}
      </Box>
    </>
  );
};
